import * as yup from "yup";
import { getStringRequiredFieldMessage } from "@shared/utils/yup-extensions";

export const TRIAL_DAYS_MAX_LENGTH = 999;

export const updateSubscriptionTrialDaysFormSchema = yup
  .object({
    trialOption: yup
      .string()
      .oneOf(["days", "date"])
      .required("You must select a trial option.")
      .label("Trial Option"),

    trialDays: yup
      .number()
      .positive()
      .integer()
      .min(1)
      .nullable()
      .max(TRIAL_DAYS_MAX_LENGTH)
      .transform((value, originalValue) =>
        originalValue?.trim() === "" ? null : value
      )
      .when("trialOption", {
        is: "days",
        then: (schema) => schema.required(getStringRequiredFieldMessage),
        otherwise: (schema) => schema.nullable(),
      })
      .label("Trial Days"),

    trialEndDate: yup
      .date()
      .typeError("Please enter a valid date.")
      .nullable()
      .min(new Date(), "Trial End Date must be in the future")
      .when("trialOption", {
        is: "date",
        then: (schema) => schema.required("Trial End Date is required."),
        otherwise: (schema) => schema.nullable(),
      })
      .label("Trial End Date"),
  })
  .required();

export type UpdateSubscriptionTrialDaysFormSchema = {
  trialOption: "days" | "date";
  trialDays?: number | null;
  trialEndDate?: Date | null;
};
